import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SalesRepresentativeInterface } from 'SupportApp/interfaces/sales-representative.interface';
import { SupportCategoryResponse } from 'SupportApp/interfaces/support-category-response.interface';
import { WebinarResponseInterface } from 'SupportApp/interfaces/webinar-response.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class SupportService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getSalesRep(): Observable<SalesRepresentativeInterface> {
        const url = this.urlsService.getUrl(this.urlsService.SALES_SUPPORT.SALES_REP);
        return this.ajaxService.getDataObserveBody<SalesRepresentativeInterface>(url);
    }

    getPageCategories(page: string): Observable<SupportCategoryResponse> {
        const url = this.urlsService.getUrl(this.urlsService.SUPPORT.CATEGORY, { page });
        return this.ajaxService.getDataObserveBody<SupportCategoryResponse>(url);
    }

    getWebinars(): Observable<WebinarResponseInterface> {
        const url = this.urlsService.SUPPORT.WEBINARS;
        return this.ajaxService.getDataObserveBody<WebinarResponseInterface>(url);
    }
}
